import Layout from '@/layout/index.vue'

export const OfertaLicitatieAchizitieRoute = {
  path: '/oferta-licitatie-achizitie',
  component: Layout,
  children: [
    {
      path: 'create/:licitatieAchizitieID',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "oferta-licitatie-create" */
          '@/features/oferta-licitatie-achizitie/views/create-update-oferta.vue'),
      name: 'OfertaLicitatieAchizitieCreateRoute',
      meta: {
        title: 'OfertaLicitatieAchizitieCreateRouteTitle',
        requiresAuth: true,
        action: 'create'
      }
    },
    {
      path: 'update/:ofertaLicitatieAchizitieID',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "oferta-licitatie-achizitie-update" */
          '@/features/oferta-licitatie-achizitie/views/create-update-oferta.vue'),
      name: 'OfertaLicitatieAchizitieUpdateRoute',
      meta: {
        title: 'OfertaLicitatieAchizitieUpdateRouteTitle',
        requiresAuth: true,
        action: 'update'
      }
    },
    {
      path: 'view/:ofertaLicitatieAchizitieID',
      component: (): Promise<any> =>
        import(
          /* webpackChunkName: "oferta-licitatie-achizitie-details" */
          '@/features/oferta-licitatie-achizitie/views/details.vue'),
      name: 'OfertaLicitatieAchizitieDetailsRoute',
      meta: {
        title: 'OfertaLicitatieAchizitieDetailsRouteTitle',
        requiresAuth: true
      }
    }
  ]
}
